import { useRef, useState } from "react";
import {
  CompanySearchApiParams,
  CompanyStock,
  Shop,
} from "../types";
import companyStockListApi from "../api/companyStockListApi";
import { Severity } from "../../../type";

const limit = 10;

/**
 * 企業用在庫一覧取得
 */
export default function useCompanyStockList(showAlert: (msg: string, severity?: Severity) => void) {
  const [total, setTotal] = useState(0); // 在庫のレコードの総数
  const [stockList, setStockList] = useState<CompanyStock[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMoreLoading, setIsMoreLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const isFastLoading = useRef(false); // 二重読み込み防止
  const [fireMoreLoadEvent, setFireMoreLoadEvent] = useState(false); // スクロール最下層に達した時、値を変更して発火させるイベント
  const [init, setInit] = useState(false);
  const [storeUpdated, setStoreUpdated] = useState("");
  const [storehouseUpdated, setStorehouseUpdated] = useState("");
  // const [shops, setShops] = useState<Shop[]>([]);

  const get = async (searchParams: CompanySearchApiParams) => {
    isFastLoading.current = true;
    setIsLoading(true);
    try {
      const res = await companyStockListApi({ ...searchParams, ...{ offset: 0, limit } });
      setTotal(res.total);
      setStockList(structuredClone(res.stocks));
      setStorehouseUpdated(res.storehouseUpdated);
      setStoreUpdated(res.companyUpdated);
      setOffset(res.stocks.length);
      // setShops(res.shops);
    } catch (err) {
      console.error(err);
      showAlert('在庫一覧情報の取得に失敗しました。', 'error');
    } finally {
      isFastLoading.current = false;
      setIsLoading(false);
    }
  };

  const getMore = async (searchParams: CompanySearchApiParams) => {
    if (stockList.length >= total || !init) {
      return;
    }

    isFastLoading.current = true;
    setIsMoreLoading(true);
    try {
      const res = await companyStockListApi({
        limit,
        offset,
        ...searchParams,
      });
      setTotal(res.total);
      setStockList((prev) => [...prev, ...res.stocks]);
      setOffset((prev) => prev + res.stocks.length);
    } catch (err) {
      console.error(err);
      showAlert('在庫一覧情報の取得に失敗しました。', 'error');
    } finally {
      isFastLoading.current = false;
      setIsMoreLoading(false);
    }
  };

  return [
    {
      total,
      stockList,
      isLoading,
      isMoreLoading,
      isFastLoading,
      fireMoreLoadEvent,
      storeUpdated,
      storehouseUpdated,
      // shops,
    },
    { setStockList, get, getMore, setFireMoreLoadEvent, setInit },
  ] as const;
}
